import { coerce } from '@meltwater/coerce';
import { DateRange } from '..//date-range';
import { AppletHostError, AppletHostErrorCode, IDateRangeRepository } from '../applet-host';
import { IDateRange, DateRangeTypes } from '../date-range';
import { ManifestClientService } from '../manifest-client.service';
const maxDateRangeDurationInMinutes = 527040;
const privateConstructorValidation = Symbol('DateRangeRepository constructor');
let instance = null;
let _dateRange;

export class DateRangeRepository implements IDateRangeRepository {
  constructor(secret, timezone) {
    if (secret !== privateConstructorValidation) {
      throw new Error('This is a private constructor. Please use getInstance');
    }

    _dateRange = new DateRange({
      rangeType: DateRangeTypes.LAST_7_DAYS,
      timezone,
    });
  }

  static async getInstance(): Promise<DateRangeRepository> {
    if (instance === null) {
      const user = await ManifestClientService.getCurrentUser();
      instance = new DateRangeRepository(privateConstructorValidation, user.timezone);
    }

    return instance;
  }

  async get(): Promise<IDateRange> {
    return _dateRange;
  }

  async set(value: IDateRange): Promise<void> {
    const dateRange = coerce(value, DateRange, 'value must be coerceable to a DateRange');

    if (dateRange.duration > maxDateRangeDurationInMinutes) {
      throw new AppletHostError({
        code: AppletHostErrorCode.MAX_DATE_RANGE_DURATION_EXCEEDED,
        message: `Duration of date range cannot exceed ${maxDateRangeDurationInMinutes} minutes`,
      });
    }

    _dateRange = dateRange;
  }
}
